// extracted by mini-css-extract-plugin
export default {"container":"ConnectExternalIdentity-module__container--eJxuo","pageCenter":"ConnectExternalIdentity-module__pageCenter--ETd0z"};